import Button from "@ergeon/core-components/exports/Button.ts";

import Layout from '@/app/Layout';

import IconHeart from '@/assets/icons/heart.svg?react';

interface EndCallPageProps {
  // True when the call closed itself after being left empty, rather than being
  // ended by the person now reading this.
  wasAbandoned?: boolean;
}

export default function EndCallPage({ wasAbandoned = false }: EndCallPageProps) {
  // A reload is the whole way back: it returns to the lobby for the same meeting
  // hash, with devices re-checked and a fresh channel join. Rebuilding that in
  // place would mean unwinding state the call teardown has already discarded.
  const onRejoin = () => window.location.reload();

  return (
    <Layout>
      <div className="flex flex-1 flex-col items-center justify-center">
        <IconHeart className="mb-6 h-20 w-20 fill-blue-1" />
        <h1 className="heading-3 text-center text-gray-900 dark:text-white">
          {wasAbandoned ? 'Call ended' : 'Thank you for the call!'}
        </h1>
        {wasAbandoned && (
          <>
            <p className="paragraph-1 mt-3 max-w-sm text-center text-gray-600 dark:text-gray-400">
              Nobody else was here for a while, so we closed the call. You can go
              back in if it is still going.
            </p>
            <Button
              className="mt-6"
              flavor="primary"
              onClick={onRejoin}
              size="large">
              Rejoin the call
            </Button>
          </>
        )}
      </div>
    </Layout>
  );
}
